import type { FormEventHandler, PropsWithChildren } from 'react'

import css from './Settings.css'

type SettingsProps = {
  onApply?: VoidFunction
}

export const Settings = ({ children, onApply }: PropsWithChildren<SettingsProps>) => {
  const handleApply: FormEventHandler<HTMLFormElement> = event => {
    event.preventDefault()
    onApply?.()
  }

  return (
    <form className={css.settings} onSubmit={handleApply}>
      <div className={css.settingsBlock}>{children}</div>
    </form>
  )
}
